import { render, staticRenderFns } from "./UpgradeToPro.vue?vue&type=template&id=47df1894&scoped=true&"
import script from "./UpgradeToPro.vue?vue&type=script&lang=js&"
export * from "./UpgradeToPro.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeToPro.vue?vue&type=style&index=0&id=47df1894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47df1894",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VImg,VMenu})
